import { Steps } from "./types";

export const obesitySteps: Steps = {
  q5: {
    id: "q5",
    backendQuestionId: 439,
    slug: "existerande-behandling",
    allowDirectAccess: true,
    text: "Har du redan behandling med läkemedel för viktnedgång?",
    clarification: "Ex. Wegowy, Saxenda eller Mounjaro",
    type: "boolean",
    flowProgress: 1 / 5,
    nextStep: (answers) => (answers?.q5 ? "o2" : "q8"),
  },

  q7: {
    id: "q7",
    backendQuestionId: 409,
    slug: "vilken-medicin",
    text: "Välj de receptbelagda läkemedel du använt för viktminskning",
    type: "multiSelect",
    options: [
      {
        text: "Xenical / Beacita (Orlistat)",
      },
      {
        text: "Saxenda (Liraglutid)",
      },
      {
        text: "Mysimba (Naltrexon/bupropion)",
      },
      {
        text: "Ozempic (Semaglutid)",
      },
      {
        text: "Wegovy (Semaglutid)",
      },
      {
        text: "Rybelsus (Semaglutid)",
      },
      {
        text: "Mounjaro (Tirzepatid)",
      },
      {
        text: "Annat (inklusive kosttillskott)",
      },
    ],
    fullWidthOptions: true,
    flowProgress: 3 / 5,
    nextStep: (answers) =>
      (answers?.q7 as string[])?.some((a) => a.includes("Annat")) ? "o4" : "o3",
  },
  q8: {
    id: "q8",
    slug: "kroppsmått",
    text: "Ange din längd och vikt",
    clarification: "Ange ner till en decimal.",
    type: "physicalStats",
    flowProgress: 2 / 4,
    nextStep: (answers) => {
      if (typeof answers?.q8 !== "number") {
        throw new Error("BMI should be a number");
      }

      if (answers?.q8 < 27) {
        return "d2";
      }

      if (answers?.q8 < 30) {
        return "q14";
      }

      return "q17";
    },
  },
  q9: {
    id: "q9",
    slug: "diagnoser-obesitas",
    text: "Har du något av följande?",
    clarification: [
      "Högt blodtryck",
      "Förhöjda blodfetter (dyslipidemi)",
      "Prediabetes/typ 2 diabetes",
      "Obstruktiv sömnapné (OSA)",
    ],
    type: "boolean",
    nextStep: () => "q9",
  },
  q14: {
    id: "q14",
    backendQuestionId: 510,
    slug: "andra-riskfaktorer",
    text: "Har du något av följande?",
    clarification: [
      "Högt blodtryck (hypertoni)",
      "Förhöjda blodfetter (dyslipidemi)",
      "Prediabetes/typ 2 diabetes",
      "Obstruktiv sömnapné (OSA)",
    ],
    type: "boolean",
    flowProgress: 3 / 4,
    nextStep: (answers) => (answers?.q14 ? "q17" : "d3"),
  },
  q17: {
    id: "q17",
    slug: "hälsosam-viktnedgång",
    text: "",
    clarification: "",
    type: "weightMotivation",
    flowProgress: 4 / 4,
    nextStep: () => null,
  },
  o2: {
    id: "o2",
    backendQuestionId: 499,
    slug: "hur-länge-har-du-haft-behandling",
    text: "Hur länge har du haft behandling?",
    clarification: "",
    type: "multipleChoice",
    fullWidthOptions: true,
    options: [
      {
        text: "Mindre än en månad",
      },
      {
        text: "1 till 3 månader",
      },
      {
        text: "3 till 6 månader",
      },
      {
        text: "6 månader eller längre",
      },
    ],
    flowProgress: 2 / 5,
    nextStep: () => "q7",
  },
  o3: {
    id: "o3",
    backendQuestionId: 498,
    slug: "vilken-dos",
    text: "Vilken dos tar du just nu? Eller vilken dos tog du senast om du har slutat med medicinen?",
    clarification: "Anges i mg eller antal tabletter.",
    type: "freetext",
    skippable: true,
    required: true,
    flowProgress: 5 / 5,
    testID: "dosageInput",
    nextStep: () => null,
  },
  o4: {
    id: "o4",
    backendQuestionId: 410,
    slug: "vilka-andra-läkemedel",
    text: "Vilka andra läkemedel har du använt för viktminskning?",
    type: "freetext",
    required: true,
    flowProgress: 4 / 5,
    nextStep: () => "o3",
  },
};
